import { SessionTimeoutDialog } from '@resurs-internal/deposits-app-components';

import { SectionProvider } from '@/contexts';
import { getAuthSession, logout, refreshAuthSession } from '@/helpers';
import { type DepositProduct } from '@/types/consumer-deposit-application-service';

import { ApplicationHandlerContent } from './ApplicationHandlerContent';

export type ApplicationHandlerProps = {
  applicationId: string;
  product: DepositProduct;
};

export const ApplicationHandler = () => {
  return (
    <SectionProvider>
      <SessionTimeoutDialog
        getAuthSession={getAuthSession}
        logout={logout}
        refreshAuthSession={refreshAuthSession}
      />
      <ApplicationHandlerContent />
    </SectionProvider>
  );
};
